import { bootstrapMontageApp } from '@core/bootstrap';
import { TPortalType } from '@core/enums/portal-type.enum';

import { RETAILER_APP } from './app/app';
import { AppComponent } from './app/app.component';

bootstrapMontageApp(AppComponent, RETAILER_APP, TPortalType.Retailer);
